/**
 * The react-query key for the monitored-servers list. Extracted to its own
 * leaf module so the card + the add/edit modals can invalidate it without
 * importing `ServerList.tsx` (which imports them — that would be a cycle).
 * `ServerList.tsx` re-exports it, so external consumers (e.g.
 * `ServerEventHistory`) keep importing it from `./ServerList.js`.
 */
export const MONITORED_KEY = ["servers", "monitored"] as const;
